<h2 mat-dialog-title style="margin-bottom: 5px">Add Attachment</h2>
<mat-dialog-content>
    <add-file #fileInput [(fileString)]="emailAttachment.Base64String" 
    [(fileType)]="emailAttachment.FileType"
    [(fileName)]="emailAttachment.OriginalFileName"
    [(fileExtension)]="emailAttachment.FileExtension"></add-file>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="save.png" label="Attach" (clickEvent)="OKClick()"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>